import styled from "styled-components";

import { colors } from "src/assets/styles/settings";

export const HighlightText = styled.span`
  background-color: ${colors.blonde};
  padding: 8px 5px;
  border-radius: 8px;
`;
